import { IGetQueryParams } from 'app/services';
import * as CryptoJS from 'crypto-js';
import queryString from 'query-string';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
const SECRET = 'aoa-aoa';

export function encryptParams<P>(params: IGetQueryParams<P>) {
  return CryptoJS.AES.encrypt(JSON.stringify(params), SECRET).toString();
}

export function createEncyptedParams<P>(params: IGetQueryParams<P>) {
  return new URLSearchParams({
    _: encryptParams(params),
  });
}

export function decryptQueryParams(
  searchParams: URLSearchParams,
): IGetQueryParams<any> {
  let parsed: IGetQueryParams<any> = { filters: {} };
  try {
    var bytes = CryptoJS.AES.decrypt(searchParams.get('_') || '', SECRET);
    parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch {}
  return {
    ...parsed,
    filters: parsed.filters || {},
    page: parsed.page || 1,
    per_page: parsed.per_page || 20,
  };
}

export function useWindowQueryParams<P>(
  initialParams: IGetQueryParams<P>,
  { skip = false }: { skip?: boolean },
) {
  const [searchParams, setSearchParams] = useSearchParams();
  let parsed = initialParams;

  if (!skip) {
    if (searchParams.has('_')) {
      parsed = decryptQueryParams(searchParams);
    } else {
      const {
        page = 1,
        per_page = 20,
        ...filters
      } = Object.fromEntries(new URLSearchParams(window.location.search));

      parsed = {
        ...parsed,
        page,
        per_page,
        filters: {
          ...parsed.filters,
          ...filters,
        },
      } as unknown as IGetQueryParams<P>;
    }
  }
  const updateState = useCallback(
    (params: IGetQueryParams<P>) => {
      if (skip) return;

      let newQueryParameters = createEncyptedParams(params);

      // let newQueryParameters = new URLSearchParams(
      //   QueryString.stringify(params, { encode: false }),
      // );

      setSearchParams(newQueryParameters, { replace: true });
    },
    [skip],
  );

  return [parsed, updateState] as const;
}
